import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import { TriggerService } from '../../../../core/trigger/trigger_service';

export function getAssistentConfigAngemieteteRaeumlichkeiten(data: any, triggerService: TriggerService): AssistentItem {
    const modul: string = (data || {}).MODUL_SELECTED || null;
    const eingabe_raum = {
        gliederung: modul === 'cfm' ? '2.5.1' : '2.4.1',
        name: 'Angemietete Räumlichkeiten',
        dataName: 'Angemietete Räumlichkeiten',
        description: 'Dies ist das Formular zur Eingabe der angemieteten Räumlichkeiten.',
        type: 'EntityForm',
        addLabel: 'Neue Räumlichkeit erfassen',
        entity: IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN,
        style: { marginLeft: 18 },
        // configFlag: 'inputWasser',
        customOnSaveDone: (entity: string, dataItem: any) => {
            triggerService.fire('reload', IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN);
        }
    };
    return eingabe_raum;
}
